import { render, staticRenderFns } from "./ServiceTitleList.vue?vue&type=template&id=6e197b56&scoped=true&lang=pug&"
import script from "./ServiceTitleList.vue?vue&type=script&lang=js&"
export * from "./ServiceTitleList.vue?vue&type=script&lang=js&"
import style0 from "./ServiceTitleList.vue?vue&type=style&index=0&id=6e197b56&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e197b56",
  null
  
)

export default component.exports